module.exports = __webpack_public_path__ + "img/bgCard.3321f91b.png";